import { render, staticRenderFns } from "./MoveBackDialog.vue?vue&type=template&id=622ad178&scoped=true&"
import script from "./MoveBackDialog.vue?vue&type=script&lang=js&"
export * from "./MoveBackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ad178",
  null
  
)

export default component.exports